import React, { useState, useEffect, useContext } from "react"
import Modal, {
  ModalHeader,
  ModalContent,
} from "../../../../../components/Modal"
import FolderDelete from "./FolderDelete"
import FolderRename from "./FolderRename"
import AppContext from "../../../../../shared/AppContext"

const FolderActionType = {
  DELETE: "delete",
  RENAME: "rename",
}

const FolderActionText = {
  DELETE: "Delete Folder",
  RENAME: "Rename Folder",
}

export default function FolderEdit(props) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [folderAction, setFolderAction] = useState({ type: "" })

  const { refetch, folderName, folderId, trackingLocation } = props
  const { trackEvent } = useContext(AppContext)

  useEffect(() => {
    if (!isModalOpen) {
      setFolderAction({ type: "", text: "" })
      refetch && refetch()
    }
  }, [isModalOpen])

  const handleModal = (action) => {
    setIsModalOpen(true)
    setFolderAction({ type: action })
    trackEvent("Folder edit option clicked", {
      location: trackingLocation,
      selected: action,
    })
  }

  const ModalHeaderText = () => {
    if (folderAction.type === FolderActionType.DELETE) {
      return FolderActionText.DELETE
    }
    return FolderActionText.RENAME
  }

  return (
    <React.Fragment>
      <div className="folder-actions">
        <p
          className="folder-action-rename"
          onClick={() => {
            handleModal(FolderActionType.RENAME)
          }}
        >
          <i className="fas fa-edit"></i> Rename
        </p>
        <p
          className="folder-action-delete"
          onClick={() => {
            handleModal(FolderActionType.DELETE)
          }}
        >
          <i className="fas fa-trash-alt"></i> Delete
        </p>
      </div>
      <Modal
        isOpen={isModalOpen}
        close={() => {
          setIsModalOpen(false)
        }}
        classes={["medium"]}
      >
        <ModalContent>
          <ModalHeader
            text={ModalHeaderText()}
            closeOption={true}
            close={() => setIsModalOpen(false)}
          />
          {folderAction.type == FolderActionType.RENAME && (
            <FolderRename
              folderId={folderId}
              folderName={folderName}
              closeModal={() => setIsModalOpen(false)}
              trackingLocation={trackingLocation}
            />
          )}
          {folderAction.type == FolderActionType.DELETE && (
            <FolderDelete
              folderId={folderId}
              folderName={folderName}
              closeModal={() => setIsModalOpen(false)}
              trackingLocation={trackingLocation}
            />
          )}
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}
